import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { leaveConference } from '../../../base/conference/actions';
import { getDeepaiTheme } from '../../functions';
const ROOT_CLASS = 'deepai-mobile-fabs';
const STYLE = `
.${ROOT_CLASS}{ display:none; }
@media (max-width: 700px), (max-height: 540px){
  .${ROOT_CLASS}{
    display:flex; position:fixed; left:0; right:0; bottom:16px; z-index:410;
    justify-content:space-between; align-items:flex-end;
    padding:0 20px; pointer-events:none;
  }
  .${ROOT_CLASS} .deepai-fab{ pointer-events:auto; }
}
.${ROOT_CLASS} .deepai-fab{
  width:56px; height:56px; border-radius:50%;
  border:1px solid var(--border); background:var(--surface); color:var(--text);
  box-shadow:var(--shadow); display:grid; place-items:center; cursor:pointer;
  backdrop-filter:blur(12px); -webkit-backdrop-filter:blur(12px);
  transition:transform .16s, background .16s;
}
.${ROOT_CLASS} .deepai-fab:active{ transform:scale(.94); }
.${ROOT_CLASS} .deepai-fab svg{ width:26px; height:26px; }
.${ROOT_CLASS} .deepai-fab.menu{ background:var(--accent); color:var(--on-accent); border-color:transparent; }
.${ROOT_CLASS} .deepai-fab.hangup{ background:var(--danger); color:#fff; border-color:transparent; }
`;
const IconMenu = (React.createElement("svg", { fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeWidth: 2, viewBox: '0 0 24 24' },
    React.createElement("path", { d: 'M4 7h16M4 12h16M4 17h16' })));
const IconClose = (React.createElement("svg", { fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeWidth: 2, viewBox: '0 0 24 24' },
    React.createElement("path", { d: 'M6 6l12 12M18 6L6 18' })));
const IconHangup = (React.createElement("svg", { fill: 'currentColor', viewBox: '0 0 24 24' },
    React.createElement("path", { d: 'M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.88 1.11-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08a.956.956 0 0 1-.29-.7c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.7l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.1-.7-.28-.78-.74-1.68-1.36-2.66-1.85a.99.99 0 0 1-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z' })));
/**
 * Mobile-only floating action bar shown when a DeepAI theme is active. A menu
 * FAB expands/collapses the (otherwise hidden) toolbar via the
 * `data-dai-toolbar` attribute the themed CSS keys off, and a hangup FAB stays
 * visible at all times for quick exit. Hidden on desktop via CSS.
 *
 * @returns {JSX.Element | null}
 */
export default function DeepaiMobileToolbar() {
    const theme = useSelector((state) => getDeepaiTheme(state));
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    useEffect(() => {
        document.documentElement.setAttribute('data-dai-toolbar', open ? 'open' : '');
        return () => document.documentElement.removeAttribute('data-dai-toolbar');
    }, [open]);
    if (!theme) {
        return null;
    }
    return (React.createElement("div", { className: ROOT_CLASS },
        React.createElement("style", null, STYLE),
        React.createElement("button", { "aria-label": open ? '閉じる' : 'メニュー', className: 'deepai-fab menu', 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: () => setOpen(o => !o), type: 'button' }, open ? IconClose : IconMenu),
        React.createElement("button", { "aria-label": '\u9000\u51FA', className: 'deepai-fab hangup', 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: () => dispatch(leaveConference()), type: 'button' }, IconHangup)));
}
